import { TrainingLogActionTypes, TrainingLogState, TrainingLogAction } from '../../constants/TrainingLog';

export const initialState: TrainingLogState = {
  latest: null,
  summaries: null,
  loading: false,
  created: false,
  updated: false,
  deleted: false,
  error: null,
};

export default function trainingLog(state = initialState, action: TrainingLogAction): TrainingLogState {
  switch (action.type) {
    // Create
    case TrainingLogActionTypes.CREATE_START:
      return {
        ...state,
        loading: true,
        created: false,
        error: null,
      };

    case TrainingLogActionTypes.CREATE_SUCCESS:
      return {
        ...state,
        loading: false,
        created: true,
        latest: action.payload,
        error: null,
      };

    case TrainingLogActionTypes.CREATE_ERROR:
      return {
        ...state,
        loading: false,
        created: false,
        error: action.error,
      };

    // Fetch Latest
    case TrainingLogActionTypes.FETCH_LATEST_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TrainingLogActionTypes.FETCH_LATEST_SUCCESS:
      return {
        ...state,
        loading: false,
        latest: action.payload,
        error: null,
      };

    case TrainingLogActionTypes.FETCH_LATEST_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Fetch Summaries
    case TrainingLogActionTypes.FETCH_SUMMARIES_START:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case TrainingLogActionTypes.FETCH_SUMMARIES_SUCCESS:
      return {
        ...state,
        loading: false,
        summaries: action.payload,
        error: null,
      };

    case TrainingLogActionTypes.FETCH_SUMMARIES_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error,
      };

    // Update
    case TrainingLogActionTypes.UPDATE_START:
      return {
        ...state,
        loading: true,
        updated: false,
        error: null,
      };

    case TrainingLogActionTypes.UPDATE_SUCCESS:
      return {
        ...state,
        loading: false,
        updated: true,
        error: null,
      };

    case TrainingLogActionTypes.UPDATE_ERROR:
      return {
        ...state,
        loading: false,
        updated: false,
        error: action.error,
      };

    // Delete
    case TrainingLogActionTypes.DELETE_START:
      return {
        ...state,
        loading: true,
        deleted: false,
        error: null,
      };

    case TrainingLogActionTypes.DELETE_SUCCESS:
      return {
        ...state,
        loading: false,
        deleted: true,
        latest: null, // Clear latest after deletion
        error: null,
      };

    case TrainingLogActionTypes.DELETE_ERROR:
      return {
        ...state,
        loading: false,
        deleted: false,
        error: action.error,
      };

    // Reset
    case TrainingLogActionTypes.RESET:
      return initialState;

    case TrainingLogActionTypes.RESET_FLAGS:
      return {
        ...state,
        created: false,
        updated: false,
        deleted: false,
        error: null,
      };

    default:
      return state;
  }
}
